import { render, staticRenderFns } from "./CenterSelect.vue?vue&type=template&id=1cc79b97&scoped=true&"
import script from "./CenterSelect.vue?vue&type=script&lang=ts&"
export * from "./CenterSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CenterSelect.vue?vue&type=style&index=0&id=1cc79b97&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc79b97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VIcon,VList,VListItem,VListItemTitle,VSimpleTable,VSpacer})
